module.exports = __webpack_public_path__ + "static/img/title.8e0b8e11.png";